Trafiken.TrafficMessages = {
    getTrafficMessagePromise: function (coordinates, departAt, type) {
        return new Promise(function(resolve, reject) {
            $.ajax({
                url: Trafiken.config.trafficMessages.url,
                type: 'POST',
                contentType: 'application/json',
                data: JSON.stringify({
                    region: Trafiken.config.trafficMessages.region,
                    sweRef99Coordinates: coordinates,
                    bufferDistance: Trafiken.config.trafficMessages.distance,
                    dateTime: departAt,
                    trafficType: type,
                }),
                success: function(data) {
                    resolve(data);
                },
                error: function() {
                    reject('Couldn\'t load traffic messages');
                },
            });
        });
    }
};

Trafiken.TrafficMessages.infoLayerOptions = {
    type: 'Gång- och cykelvägsstörning',
    templateName: 'popup-bike-situation.hbs',
    markerIcon: function(f) {
        return Trafiken.icons.getIcon(f.iconId, [32, 26], [16, 13]);
    },
    getPosition: function (o) {
        return o.wgs84Position && L.GeoJSON.coordsToLatLng(o.wgs84Position.coordinates);
    },
    clusterOptions: {
        clusterIconId: function(markers) {
            return Trafiken.icons.clusterIconId(markers);
        }
    }
}
